export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-04.85ecf6b4.jpg";